import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            来看看其他吃瓜群众怎么说，加入吃瓜大家庭
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="rounded-xl p-5 bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.author}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800">{comment.author}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                "{comment.content}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}